import Swal from 'sweetalert2';
import tingle from 'tingle.js';

class UIUtils {

    static toast(icon, title, onCloseCallback) {
        Swal.fire({
            toast: true,
            icon: icon,
            title: title,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
            didClose: () => {
                if (onCloseCallback) {
                    onCloseCallback();
                }
            }
        });
    }

    static openModal(url, postData, onOpen, onClose, beforeClose) {
        let $modal = new tingle.modal({
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            onOpen: onOpen,
            onClose: function () {
                if (typeof onClose === 'function') {
                    onClose();
                }
                $modal.destroy();
            },
            beforeClose: beforeClose
        });

        let requestOptions = {
            method: 'GET',
        };

        if (postData) {
            requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData)
            };
        }

        fetch(url, requestOptions)
            .then(response => response.text())
            .then(htmlContent => {
                $modal.setContent(htmlContent);
                $modal.open();
                executeModalScripts($modal.modal);
            })
            .catch(error => {
                console.error('Error fetching modal content:', error);
                $modal.setContent('<p>Error loading content. Please try again later.</p>');
                $modal.open();
            });

        function executeModalScripts(modalElement) {
            const scripts = modalElement.querySelectorAll('script');
            scripts.forEach((oldScript) => {
                const newScript = document.createElement('script');
                Array.from(oldScript.attributes)
                    .forEach(attr => newScript.setAttribute(attr.name, attr.value));
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));

                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        }

        return $modal;
    }

    static redirect(url) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }
}

export default UIUtils;